import * as Sentry from '@sentry/react'

class InsecureRedirectError extends Error {
  constructor(...params) {
    super(...params)

    this.name = 'InsecureRedirectError'
  }
}

export const captureInsecureRedirect = uri =>
  Sentry.captureException(
    new InsecureRedirectError(`Insecure redirect attempt to ${uri}`)
  )



// WEBPACK FOOTER //
// ./src/utils/sentry.js